export default {
  insuranceOfflineTitle: {
    id: 'insurance_offline_banner_info_title',
    defaultMessage: "We don't offer this protection plan anymore.",
  },
  insuranceOfflineContent: {
    id: 'insurance_offline_banner_info_description',
    defaultMessage:
      'To stay protected, add one of our (great) new plans to your cart.',
  },
  noStockTitle: {
    id: 'no_stock_banner_info_title',
    defaultMessage: 'One or two items in your cart are no longer available',
  },
  noStockDescription: {
    id: 'no_stock_banner_info_description',
    defaultMessage: 'Please update your cart to continue.',
  },
}
